(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ModalBrandFactory', ModalBrandFactory);

    /** @ngInject */
    function ModalBrandFactory($uibModal) {

        var factory = {
            listModal: listModal,
        }

        return factory;

        function listModal() {
            return listBrandModal();
        }

        function listBrandModal() {
            return $uibModal.open({
                templateUrl: "app/admin/brand/modal-brand.html",
                windowClass: 'modal-side-menu',
                size: 'md',
                controller: "ModalBrandController",
                controllerAs: "vm",
                backdrop: 'static',
                resolve: {
                    brand: function () {
                    },
                    onFlyerForm: function () {
                        return false;
                    },
                }
            }).result;
        }
    }
})();
